import { Modal } from "@/components/ui/modal";
import { useWikiRevisions } from "@/hooks/use-wiki";
import { format } from "@/lib/format";
import { WikiLabels } from "@/lib/labels/wiki";

export function WikiHistory({ slug, onClose }: { slug: string; onClose: () => void }) {
	const { data, isLoading, isError } = useWikiRevisions(slug);

	return (
		<Modal title={WikiLabels.historyTitle} onClose={onClose}>
			{isLoading && <p className="text-xs italic text-muted-foreground">{WikiLabels.loading}</p>}

			{!isLoading && isError && (
				<p className="text-xs text-destructive">{WikiLabels.historyLoadError}</p>
			)}

			{!isLoading && !isError && data && data.length === 0 && (
				<p className="text-xs italic text-muted-foreground">{WikiLabels.noRevisions}</p>
			)}

			{!isLoading && !isError && data && data.length > 0 && (
				<ul className="flex flex-col gap-1.5">
					{data.map((revision) => (
						<li
							key={revision.id}
							className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 text-xs"
						>
							<span className="font-mono text-muted-foreground">
								{format.dateTime(revision.created_at)}
							</span>
							<span className="min-w-0 break-words text-foreground">
								{WikiLabels.revisionLabel(revision.author)}
							</span>
						</li>
					))}
				</ul>
			)}
		</Modal>
	);
}
